import { useEffect, useState } from "react";
import { Rocket } from "lucide-react";

function fmt(ms) {
  if (ms <= 0) return null;
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}s ${m}dk`;
  if (m > 0) return `${m}dk ${sec}sn`;
  return `${sec}sn`;
}

export function BoostCountdown({ expiresAt, className }) {
  const target = () => new Date(expiresAt).getTime() - Date.now();
  const [left, setLeft] = useState(target);
  useEffect(() => {
    setLeft(target());
    const iv = setInterval(() => setLeft(new Date(expiresAt).getTime() - Date.now()), 1000);
    return () => clearInterval(iv);
  }, [expiresAt]);
  const t = fmt(left);
  if (!t) return null;
  return (
    <span data-testid="boost-countdown" className={`inline-flex items-center gap-1.5 text-xs font-bold text-white brand-gradient px-3 py-1.5 rounded-full ${className || ""}`}>
      <Rocket className="h-3.5 w-3.5" /> Öne çıkıyor · {t}
    </span>
  );
}
